<template>
  <div class="calendar">
    <div class="selectbox">
      <el-form inline>
        <el-form-item>
          <el-button icon="el-icon-arrow-left" size="mini" @click="handleQuickChange('prev')"></el-button>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="curYear"
            @change="selectTime()"
            placeholder="请选择"
            size="mini"
            class="timeselect"
          >
            <el-option
              v-for="item in yearOptions"
              :key="item.key"
              :value="item.value"
              :label="item.label"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="curMonth"
            @change="selectTime()"
            placeholder="请选择"
            size="mini"
            class="timeselect"
          >
            <el-option
              v-for="item in monthOptions"
              :key="item.key"
              :value="item.value"
              :label="item.label"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
            <el-button size="mini" icon="el-icon-arrow-right" @click="handleQuickChange('next')"></el-button>
        </el-form-item>
      </el-form>
    </div>
    <div id="calendar">
      <table class="calendar-table" :style="{width}">
        <thead>
          <tr>
            <th v-for="(item, i) in weeks" :key="i">{{ item }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(dates, i) in res" :key="i" :style="{height: tbodyHeight}">
            <td
              style="position:relative"
              v-for="(item, index) in dates"
              :key="index"
              :class="{notCurMonth: !item.isCurMonth, currentDay: item.date === curDate, selectDay: item.isSelected, rangeSelectd: item.isRangeSelected, weekend: item.isWeekend}"
              @mouseover="handleItemMove(item, i, index)"
            >
              <div class="timecontent">
                <div v-for="data in dataList" :key="data.index">
                  <div v-if="data.appointDate == item.date" class="calendarcontent">
                    <div class="list" @click="showDetail(data)">
                      {{data.appointStartTime}}~{{data.appointEndTime}}(已预约)
                      <!-- <br />
                      {{data.photographyMethod == 1 ? '云现场' : '现场'}}:&nbsp;{{data.orderCode}}({{data.addName}}) -->
                    </div>
                  </div>
                </div>
              </div>
              <span class="time">{{item.date.split('-').slice(2).join('-')}}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {
  getDaysInMonth,
  handleCrateDate,
  handleCreateDatePicker,
  parseTime
} from "./dateHandle";
import { getAppointmentRecord } from "@/api/request";

export default {
  props: {
    selectMode: {
      type: String,
      default: "click"
    },
    startOfWeek: {
      type: Number,
      default: 1
    },
    canSelect: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "100%"
    },
    tbodyHeight: {
      type: String,
      default: "100px"
    }
  },
  data() {
    return {
      monthOptions: [],
      equipmentId: null,
      tagName: [],
      dataList: [],
      yearOptions: [],
      weeks: ["一", "二", "三", "四", "五", "六", "日"],
      curYear: new Date().getFullYear(), // 当前年
      curMonth: new Date().getMonth(), // 当前月
      days: 0, // 当前月总共天数
      curDate: parseTime(new Date().getTime()), // 当前日期 yyyy-MM-dd 格式，用来匹配是否是当前日期
      prevDays: [], // 非当前月的上一月展示的日期
      rearDays: [], // 非当前月的下一月展示的日期
      curDays: [], // 当前月的日期
      showDays: [], // 总共展示的42个日期
      res: [], // 二维数组
      selectedDates: [], // 选中的日期
      selectedMode: false, // true表示点击， false表示滑动
      moveIndex: [], // 两个，第一个是起始，第二个是结束
      canMove: false // 当moveIndex数组有一个值时，可以触发滑动
    };
  },
  watch: {
    curMonth: {
      handler(val) {
        this.handleGetDays(this.curYear, val, this.startOfWeek);
      }
    },
    curYear: {
      handler(val) {
        this.handleGetDays(val, this.curMonth, this.startOfWeek);
      }
    }
  },
  created() {
    this.weeks.unshift(...this.weeks.splice(this.startOfWeek - 1)); // 渲染表头
    this.handleGetDays(this.curYear, this.curMonth, this.startOfWeek); // 渲染表格内容
    this.selectedMode = this.selectMode === "click"; // 判断选择模式
  },
  mounted() {
    // this.getList();
    this.monthOptions = handleCreateDatePicker().months;
    this.yearOptions = handleCreateDatePicker().years;
    if (localStorage.selectedDates)
      this.selectedDates = JSON.parse(localStorage.selectedDates);
  },
  methods: {
    getList(id) {
      this.dataList = []
      this.equipmentId = id
      let month = this.curMonth + 1;
      if (month < 10) {
        month = "0" + month;
      }
      let parms = this.curYear + "-" + month;
        getAppointmentRecord({
          equipmentId: id,
          queryTMonth: parms
        }).then(res => {
          this.dataList = res.data
        })
    },
    selectTime() {
      this.getList(this.equipmentId);
    },
    handleGetDays(year, month, startOfWeek) {
      this.showDays = [];
      this.days = getDaysInMonth(year, month);
      let firstDayOfWeek = new Date(`${year}-${month + 1}-01`).getDay();

      // 处理周起始日
      const obj = {
        1: "一",
        2: "二",
        3: "三",
        4: "四",
        5: "五",
        6: "六",
        0: "日"
      };
      const firstDayInCN = obj[firstDayOfWeek];
      const index = this.weeks.indexOf(firstDayInCN);

      this.prevDays = handleCrateDate(year, month, 1, index + 1, "prev");
      this.rearDays = handleCrateDate(
        year,
        month,
        1,
        42 - this.days - index,
        "rear"
      );
      this.curDays = handleCrateDate(year, month, 1, this.days);

      this.showDays.unshift(...this.prevDays);
      this.showDays.push(...this.curDays);
      this.showDays.push(...this.rearDays);
      this.res = this.handleFormatDates(this.showDays);
      this.res.pop();
    },
    handleFormatDates(arr, size = 7) {
      // 传入长度42的原数组，最终转换成二维数组
      const arr2 = [];
      for (let i = 0; i < size; i++) {
        const temp = arr.slice(i * size, i * size + size);
        arr2.push(temp);
      }
      return arr2;
    },
    handleItemMove(data, i, j) {
      if (this.canMove && !this.selectedMode) {
        const index = i * 7 + j;
        this.showDays.forEach(item => {
          item.isSelected = false;
          item.isRangeSelected = false;
        });
        // 让第一个日期和最后一个日期显示蓝色高亮
        this.showDays[index].isSelected = true;
        this.showDays[this.moveIndex[0]].isSelected = true;

        // 不同情况的判断，当用户的鼠标滑动进日期的索引小于起始日期的索引，要做if else处理
        if (this.moveIndex[0] < index) {
          for (let i = this.moveIndex[0] + 1; i < index; i++) {
            this.showDays[i].isRangeSelected = true;
          }
        } else {
          for (let i = index + 1; i < this.moveIndex[0]; i++) {
            this.showDays[i].isRangeSelected = true;
          }
        }
      }
    },
    handleQuickChange(type) {
      if (type === "prev") {
        this.curMonth--;
        if (this.curMonth === -1) {
          this.curMonth = 11;
          this.curYear -= 1;
        }
      } else if (type === "next") {
        this.curMonth++;
        if (this.curMonth === 12) {
          this.curMonth = 0;
          this.curYear += 1;
        }
      }
      this.getList(this.equipmentId);
    }
  }
};
</script>

<style scoped lang="scss">
.time {
  position: absolute;
  top: 0;
  right: 0;
}
.timeselect {
  width: 100px;
}
.calendar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.calendar-table {
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 15px 15px;
  transition: 0.3s;
  thead tr {
    height: 10px;
    text-align: center;
  }
  tbody tr {
    &:first-child td {
      border-top: 1px solid #e2e2e2;
    }
    td {
      position: absolute;
      // cursor: pointer;
      border-right: 1px solid #e2e2e2;
      border-bottom: 1px solid #e2e2e2;
    }
  }
}
.timecontent {
  inset: 0px;
  overflow: scroll;
  height: 100px;
  display: flex;
  flex-flow: column;
}

.calendarcontent {
  font-size: 12px;
  margin-top: 10px;
  .list {
    position: relative;
  }
  span {
    display: block;
    width: 7px;
    height: 7px;
    top: 3px;
    left: -14px;
    position: absolute;
    border-radius: 10px;
  }
  div {
    margin-left: 15px;
  }
  .redcolor {
    background: #f86a4a;
  }
  .greycolor {
    background: grey;
  }
  .bluecolor {
    background: #4d6fff;
  }
  .greencolor {
    background: #4caf50;
  }
  .origincolor {
    background: #e6a23c;
  }
}
.notCurMonth {
  color: #c0c4cc;
}
.currentDay {
  color: #4d6fff;
  // background-color: #08a8a0;
  background-color: rgba(24, 144, 255, 0.1);
}
.selectDay {
  color: #fff;
  background-color: #4d6fff;
}
.rangeSelectd {
  color: #606266;
  background-color: #dee2e9;
}
.weekend {
  color: #f73131;
}
.finish {
  text-decoration: line-through;
}
</style>